import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import './PremiumBreadcrumb.css'

export interface PremiumBreadcrumbItem {
  label: string
  to?: string
}

interface PremiumBreadcrumbProps {
  items: PremiumBreadcrumbItem[]
  className?: string
}

const PremiumBreadcrumb: FC<PremiumBreadcrumbProps> = ({ items, className = '' }) => {
  if (!items.length) return null

  return (
    <div className={`premium-breadcrumb-bar ${className}`.trim()}>
      <span className='premium-breadcrumb-bar__icon' aria-hidden='true'>
        <svg width='13' height='13' viewBox='0 0 24 24' fill='none'>
          <path
            d='M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V9.5z'
            stroke='currentColor'
            strokeWidth='1.8'
            strokeLinejoin='round'
          />
        </svg>
      </span>
      <nav aria-label='Breadcrumb' className='premium-breadcrumb'>
      <ol className='premium-breadcrumb__list'>
        {items.map((item, index) => {
          const isLast = index === items.length - 1

          return (
            <li key={`${item.label}-${index}`} className='premium-breadcrumb__item'>
              {index > 0 && (
                <span className='premium-breadcrumb__separator' aria-hidden='true'>
                  <svg width='14' height='14' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M9 6l6 6-6 6'
                      stroke='currentColor'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </span>
              )}
              {item.to && !isLast ? (
                <Link to={item.to} className='premium-breadcrumb__link'>
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`premium-breadcrumb__current${isLast ? ' premium-breadcrumb__current--active' : ''}`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
      </nav>
    </div>
  )
}

export default PremiumBreadcrumb
